import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => {
    const saved = localStorage.getItem('chillverify-cart');
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem('chillverify-cart', JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (product) => {
    if (!product?.id) {
      console.warn('addToCart: missing product id', product);
      return;
    }
    const id = String(product.id);
    setCartItems(prev => {
      const existing = prev.find(item => String(item.id) === id);
      if (existing) {
        return prev.map(item =>
          String(item.id) === id ? { ...item, quantity: item.quantity + 1 } : item
        );
      }
      return [...prev, { ...product, id, quantity: 1 }];
    });
  };

  const removeFromCart = (productId) => {
    const id = String(productId);
    setCartItems(prev => prev.filter(item => String(item.id) !== id));
  };

  const updateQuantity = (productId, delta) => {
    const id = String(productId);
    setCartItems(prev => prev.map(item => {
      if (String(item.id) === id) {
        const newQty = item.quantity + delta;
        return newQty > 0 ? { ...item, quantity: newQty } : item;
      }
      return item;
    }).filter(item => item.quantity > 0));
  };

  const clearCart = () => {
    setCartItems([]);
  };

  const cartCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);
  const cartTotal = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);

  return (
    <CartContext.Provider value={{
      cartItems,
      cartCount,
      cartTotal,
      addToCart,
      removeFromCart,
      updateQuantity,
      clearCart,
    }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};
